import React from 'react';
import { DownloadIcon } from 'lucide-react';
import type { Resource } from '../../types/article';
const formatStyle: Record<Resource['format'], {
  tab: string;
  label: string;
}> = {
  Excel: {
    tab: 'bg-[#1B7A3D]',
    label: 'XLSX'
  },
  PDF: {
    tab: 'bg-[#C0362C]',
    label: 'PDF'
  },
  Word: {
    tab: 'bg-brand',
    label: 'DOCX'
  }
};
export function ResourceCard({
  resource,
  onDownload
}: {
  resource: Resource;
  onDownload: (r: Resource) => void;
}) {
  return <article className="flex h-full flex-col rounded-[14px] border border-canvas-line bg-white p-5" data-id="element-607" data-mp="1u6wbuvzuj8sm">
      <DocThumbnail resource={resource} data-id="element-608" data-mp="1p8l5iv8rfgf5" />
      <span className="mt-5 self-start rounded-full bg-canvas-warm px-2.5 py-1 text-[12px] font-semibold text-ink" data-id="element-609" data-mp="1k6vtbc9swwph">{resource.type}</span>
      <h3 className="mt-3 text-[18px] font-semibold leading-[1.3] tracking-[-0.02em] text-ink" data-id="element-610" data-mp="1f9vkitlkhfuo">{resource.title}</h3>
      <p className="mt-2 text-[15px] leading-[1.55] text-ink-soft" data-id="element-611" data-mp="3ekn7mp32s4r9">{resource.copy}</p>
      <div className="mt-auto flex items-center justify-between gap-3 pt-5" data-id="element-612" data-mp="39mv6d4gjj6ae">
        <span className="text-[13px] text-ink-muted" data-id="element-613" data-mp="233w5jsupdk89">
          {resource.format} · {resource.size}
        </span>
        <button type="button" onClick={() => onDownload(resource)} className="inline-flex h-11 items-center gap-2 rounded-[7px] bg-brand px-4 text-[14px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover" data-id="element-614" data-mp="285ljphd82e0k">
          <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-615" data-mp="2lwglyat7twv6" />
          Download free
        </button>
      </div>
    </article>;
}
function DocThumbnail({
  resource
}: {
  resource: Resource;
}) {
  const style = formatStyle[resource.format];
  const sheet = resource.format === 'Excel';
  return <div className="flex h-[168px] items-end justify-center overflow-hidden rounded-[10px] bg-canvas-warm pt-6" aria-hidden="true" data-id="element-616" data-mp="2h3ng1jm0gihi">
      <div className="relative h-full w-[64%] rounded-t-[6px] bg-white px-4 pt-4 shadow-[0_8px_24px_-12px_rgba(11,11,11,0.25)]" data-id="element-617" data-mp="34syl3dae8z1g">
        <span className={`absolute right-3 top-3 rounded-[4px] px-1.5 py-0.5 text-[10px] font-bold text-white ${style.tab}`} data-id="element-618" data-mp="3jh02ndyr1rv1">{style.label}</span>
        <div className="h-2 w-[55%] rounded-full bg-ink/80" data-id="element-619" data-mp="3ej6tcc25ghqj" />
        <div className="mt-1.5 h-1.5 w-[35%] rounded-full bg-ink/20" data-id="element-620" data-mp="3ag1ucjha2y6n" />
        {sheet ? <div className="mt-4 grid grid-cols-4 gap-px overflow-hidden rounded-[3px] bg-canvas-line" data-id="element-621" data-mp="35hh49cvqpuvx">
            {Array.from({
          length: 20
        }, (_, i) => <div key={i} className={`h-3.5 ${i < 4 ? 'bg-[#E6F4EA]' : 'bg-white'}`} data-id="element-622" data-mp="30jp45vkxz2gn" />)}
          </div> : <div className="mt-4 space-y-2" data-id="element-623" data-mp="2qsauww36uoab">
            {[100, 92, 96, 70, 88, 94, 60].map((w, i) => <div key={i} className="h-1.5 rounded-full bg-ink/10" style={{
          width: `${w}%`
        }} data-id="element-624" data-mp="2mqpp1up2na9m" data-mpi={i} />)}
          </div>}
      </div>
    </div>;
}